/** @fileoverview Skeleton shown while the Task Tracker matrix is loading. */

import { Box, Skeleton, Stack } from '@mantine/core'

export function TaskTrackerLoadingState() {
  return (
    <Box py="md">
      <Stack spacing="md">
        <Skeleton height={50} radius="md" />
        <Skeleton height={300} radius="md" />
      </Stack>
    </Box>
  )
}
